import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const slides = [
  {
    title: '好色tv – 您的专属高清影院',
    subtitle: '海量影视资源 · VIP会员尊享 · 每日更新',
    cta: '立即体验',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20home%20theater%20with%20large%20screen%20displaying%20colorful%20abstract%20film%20visuals%2C%20warm%20amber%20and%20gold%20accent%20lighting%2C%20luxurious%20viewing%20environment%2C%20premium%20entertainment%20atmosphere%2C%20professional%20interior%20photography%2C%20rich%20dark%20tones%20with%20warm%20highlights&width=1800&height=900&seq=hero-slide-01&orientation=landscape',
  },
  {
    title: '2025年度最热大片来袭',
    subtitle: '《流浪地球3》《封神第二部》等热门影片已上线',
    cta: '立即观看',
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20scene%20with%20dramatic%20sci-fi%20elements%20and%20ancient%20fantasy%20warriors%2C%20warm%20golden%20and%20crimson%20lighting%2C%20dark%20atmospheric%20background%2C%20blockbuster%20film%20visual%20style%2C%20grandiose%20scale&width=1800&height=900&seq=hero-slide-02&orientation=landscape',
  },
  {
    title: 'VIP会员限时特惠',
    subtitle: '首月仅需9.9元，畅享4K超清画质',
    cta: '开通VIP',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20golden%20VIP%20membership%20concept%20with%20sparkling%20effects%20and%20elegant%20dark%20background%2C%20warm%20amber%20and%20gold%20lighting%20accents%2C%20premium%20exclusive%20atmosphere%2C%20high-end%20commercial%20photography%20style&width=1800&height=900&seq=hero-slide-03&orientation=landscape',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center w-full px-4">
          <h1 className="text-2xl md:text-5xl font-heading font-bold text-white mb-3 md:mb-4 leading-tight">
            {slides[current].title}
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8">
            {slides[current].subtitle}
          </p>
          <div className="flex items-center justify-center gap-3">
            <button className="px-6 md:px-8 py-2.5 md:py-3 bg-primary-500 text-white rounded-md text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer">
              {slides[current].cta}
            </button>
            <Link
              to="/category/dianying"
              className="px-6 md:px-8 py-2.5 md:py-3 border border-white/30 text-white rounded-md text-sm md:text-base font-medium whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              浏览内容
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`幻灯片 ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}